import { render, staticRenderFns } from "./LicenseExpiredAdviseModal.vue?vue&type=template&id=73fd389f"
import script from "./LicenseExpiredAdviseModal.vue?vue&type=script&lang=js"
export * from "./LicenseExpiredAdviseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports